import i18n from 'i18next';
import { type LanguageCode } from './availableLanguages';

type I18nResources<K extends string> = {
  [lang in LanguageCode]: Record<K, string>;
}

export default function i18nRegister<K extends string>(
  path: string, resources: I18nResources<K>, startsFrom: string = 'src',
) {
  let namespace = path;
  if (startsFrom.length > 0) {
    const pathRegExp = new RegExp(`${startsFrom}`);
    namespace = path.split(pathRegExp)?.[1];
    if (!namespace) throw Error(`Namespace inválid: "${startsFrom}" not found in path`);
  }
  Object.entries(resources).forEach(([lang, data]) => {
    if (!i18n.hasResourceBundle(lang, namespace)) {
      i18n.addResourceBundle(lang, namespace, data);
    }
  });
  return namespace;
}
